import React, { Component } from 'react'
import {
    Container,
    Row,
    Col,
    ListGroup,
    ListGroupItem
} from 'reactstrap'
import './empresa.css'
// https://i.ibb.co/WyfNhr5/ubicacion.png
import Mapa from '../mapa'
import Social from './social'
import { ordenarDias, armarDia } from '../utilitarios/horarios'
import Emp from '../utilitarios/infoEmpresa'

const empresa = new Emp()

export default class Empresa extends Component {

    constructor(props) {
        super(props);
        this.state = {
            infoEmpresa: empresa,
            cssEfectoDescripcion: 'descripcionEmpresaHidden'
        }
    }

    
    componentWillMount() {
        let _this = this

        empresa.getInfoEmpresa().then(data => {
            _this.setState({
                infoEmpresa: data,
                cssEfectoDescripcion: 'descripcionEmpresaShow'
            })
        })
    }


    render() {
        return (
            <div>
                <div className="infoEmpresa">
                    <Container>
                        <h2 className="acercaDeNosotros">Acerca de nosotros</h2>
                        <Row>
                            {/* <Col className={`descripcionEmpresa ${this.state.cssEfectoDescripcion}`}> */}
                            <Col className={`descripcionEmpresa`}>
                                {
                                    this.state.infoEmpresa.Descripcion
                                }
                                {/* Eléctrica Caporale es un joven emprendimiento que busca lograr vínculos de confianza con los clientes, brindándoles soluciones a sus necesidades. */}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="4">
                                <Row>
                                    <Col>
                                        <ListGroup className={`horarioEmpresa ${this.state.cssEfectoDescripcion}`}>
                                            <ListGroupItem active tag="button" color="dark" action>Horario de atención:</ListGroupItem>
                                            {
                                                ordenarDias(this.state.infoEmpresa.horarios).map((dia) => {
                                                    return (
                                                        <ListGroupItem color="warning" key={dia.Dia} >
                                                            {
                                                                armarDia(dia)
                                                            }
                                                        </ListGroupItem>
                                                    )
                                                })
                                            }
                                        </ListGroup>
                                    </Col>
                                </Row>

                            </Col>
                            <Col xs="12" md="8" className="infoMapa">
                                <Row>
                                    <Mapa />
                                    <div className="empresaDireccion">
                                        Dirección: {this.state.infoEmpresa.Direccion}
                                    </div>
                                </Row>
                                <Row>
                                    <Social />
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div >

        )
    }
}

{/* <Container>
                    <Row>
                        <Col md={8}>
                            <Row> 
                                Eléctrica Caporale es un joven emprendimiento que busca lograr vínculos de confianza con los clientes, brindándoles soluciones a sus necesidades.
                            </Row>
                            <Row className="Telefono">
                                <FontAwesomeIcon className="Icono" icon={faPhoneSquare}/>4724 5763
                            </Row>
                        </Col>
                        <Col md={4}>
                            <img className="ImgUbicacion" src="https://i.ibb.co/WyfNhr5/ubicacion.png" alt="ubicacion" />
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                        </Col>
                    </Row>
                </Container> */}